import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import type { ObjPathProxy } from "ts-object-path";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	count?: number;
	labelKey?: ObjPathProxy<unknown, string>;
	action?: ReactNode;
	disableBottomPadding?: boolean;
};

export const ListCountBarRedesign: FC<Props> = ({
	count,
	labelKey,
	action,
	disableBottomPadding = false,
}) => {
	const { t } = useResource();
	const theme = useTheme();
	const text = labelKey ? t(labelKey, { count }) : undefined;

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="flex-end"
			px={theme.spacingTokens.lg}
			pt={theme.spacingTokens.sm}
			pb={
				disableBottomPadding ? theme.spacingTokens.none : theme.spacingTokens.sm
			}
			bgcolor={theme.palette.grey[50]}
		>
			{text !== undefined && (
				<Typography
					variant="caption"
					color={theme.palette.grey[500]}
					marginRight="auto"
				>
					{text}
				</Typography>
			)}
			{action}
		</Stack>
	);
};
